import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export default class CaseManagerService {
  static resource = 'case-managers';

  static getAddStudentsModalData(caseManagerId: number | string): ApiPromise {
    return HTTP.get(`${this.resource}/${caseManagerId}/students/available-to-add`);
  }

  static attachStudentsRequest(students: number[], caseManagerId: number | string): ApiPromise {
    return HTTP.post(`${this.resource}/${caseManagerId}/attach-students`, { students });
  }

  static detachStudentsRequest(students: number[], caseManagerId: number | string): ApiPromise {
    return HTTP.post(`${this.resource}/${caseManagerId}/detach-students`, { students });
  }
}
